module.exports = __webpack_public_path__ + "media/cafe_genuss_webvideo_quer_NEU_V1.4b51fc9b.mp4";